<template>
  <a :href="link" :target="target">
    <button>{{ text }}</button>
  </a>
</template>

<script>
export default {
  name: "Button",
  props: {
    text: String,
    link: String,
    target: {
      type: String,
      default: "_self",
    },
  },
  /* methods: {
    link_to() {
      this.$router.push(this.link);
    },
  }, */
};
</script>

<style scoped>
button {
  color: #16181a;
  background-color: #ffc737;
  font-family: "Montserrat", sans-serif;
  font-size: 2em;
  font-weight: 400;
  text-align: center;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  display: inline-block;
  padding: 0.25em 1.1em;
  box-shadow: 4px 4px 6px #00000080;
  align-self: flex-start;
}

@media screen and (max-width: 624px) {
  button {
    font-size: 1.4em;
  }
}

@media screen and (max-width: 400px) {
  button {
    font-size: 1.2em;
  }
}
</style>
